import type { SvgIconProps } from "@mui/material";
import { AlertCircleIcon } from "../ui/alert-circle";
import { ArrowDownIcon } from "../ui/arrow-down";
import { ArrowUpIcon } from "../ui/arrow-up";
import { BuildingIcon } from "../ui/building";
import { CalendarIcon } from "../ui/calendar";
import { CheckIcon } from "../ui/check";
import { ChevronDownIcon } from "../ui/chevron-down";
import { ChevronLeftIcon } from "../ui/chevron-left";
import { ChevronRightIcon } from "../ui/chevron-right";
import { ChevronUpIcon } from "../ui/chevron-up";
import { DownloadIcon } from "../ui/download";
import { FilterIcon } from "../ui/filter";
import { HelpCircleIcon } from "../ui/help-circle";
import { LogoutIcon } from "../ui/log-out";
import { MailICon } from "../ui/mail";
import { MessageBalloonIcon } from "../ui/message-balloon";
import { MinusCircleIcon } from "../ui/minus-circle";
import { PackageIcon } from "../ui/package";
import { PlusIcon } from "../ui/plus";
import { ProposalIcon } from "../ui/proposal";
import { SearchIcon } from "../ui/search";
import { TrashIcon } from "../ui/trash";
import { TruckIcon } from "../ui/truck";
import { UserIcon } from "../ui/user";
import { UsersIcon } from "../ui/users";
import { XCloseIcon } from "../ui/x-close";

export const IconMap = {
  alertCircle: AlertCircleIcon,
  arrowDown: ArrowDownIcon,
  arrowUp: ArrowUpIcon,
  building: BuildingIcon,
  calendar: CalendarIcon,
  check: CheckIcon,
  chevronDown: ChevronDownIcon,
  chevronUp: ChevronUpIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  download: DownloadIcon,
  filter: FilterIcon,
  helpCircle: HelpCircleIcon,
  logOut: LogoutIcon,
  mail: MailICon,
  messageBalloon: MessageBalloonIcon,
  minusCircle: MinusCircleIcon,
  package: PackageIcon,
  plus: PlusIcon,
  proposal: ProposalIcon,
  search: SearchIcon,
  trash: TrashIcon,
  truck: TruckIcon,
  user: UserIcon,
  users: UsersIcon,
  xClose: XCloseIcon,
};

export type BaseIconName = keyof typeof IconMap;
export type BaseIconProps = { name?: BaseIconName } & SvgIconProps;
